import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import routes from "./routes";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import vueResource from "vue-resource";
import VueMoment from "vue-moment";
import Lightbox from "vue-easy-lightbox";
import VModal from "vue-js-modal";
import axios from "axios";
import VueMq from "vue-mq";
import VueTabs from "vue-nav-tabs/dist/vue-tabs.js";
import "vue-nav-tabs/themes/vue-tabs.css";
import VTooltip from "v-tooltip";
import VPopover from "v-tooltip";

Vue.prototype.$http = axios;

Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(vueResource);
Vue.use(VueMoment);
Vue.config.productionTip = false;
Vue.use(Lightbox);
Vue.use(VModal);
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    smallLaptop: 1050,
    laptop: 1440,
    desktop: Infinity
  }
});
Vue.use(VueTabs);
Vue.use(VTooltip);
Vue.use(VPopover);

const router = new VueRouter({
  routes
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
